import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {forkJoin, Observable, Subscription} from "rxjs";
import * as _ from "lodash";
import {ShipmentsService} from "../services/shipments.service";
import {ShipmentRoutesService} from "../services/shipment-routes.service";
import {Shipment} from "../services/shipment";
import {ShipmentRoute} from "../services/shipment-route";

@Component({
    selector: 'app-shipment-details',
    templateUrl: './shipment-details.component.html',
    styleUrls: ['./shipment-details.component.scss'],
})
export class ShipmentDetailsComponent implements OnInit {

    loading: boolean;
    private shipmentId: any;
    public shipment: Shipment;
    public _shipment: Shipment;

    public allShipmentRoutes: ShipmentRoute[];
    public shipmentRoutes: ShipmentRoute[];
    private shipmentsUpdatedObservable: Observable<boolean>;
    private shipmentsUpdatedSubscribtion: Subscription;

    constructor(
        public router: Router,
        private route: ActivatedRoute, public shipmentsService: ShipmentsService,
        public shipmentRoutesService: ShipmentRoutesService) {
    }

    ngOnInit(): void {

        this.shipmentsUpdatedObservable = this.shipmentsService.getShipmentsUpdatedStream();
        this.loading = true;

        this.route.queryParams.subscribe(params => {
            if (params.branch && params.nota_number) {

                this.shipmentsService.getShipments(1, {
                    branch: params.branch,
                    nota_number: params.nota_number
                }).then((result) => {
                    if (result.count > 0) {
                        this.router.navigate(['/', 'shipment', result.results[0].id])
                    }
                })
            }

        })

        this.route.params.subscribe(params => {
            if (params.shipmentId) {
                this.shipmentId = params['shipmentId'];
                this.loadShipment();
            } else {
            }
        });

        this.shipmentsUpdatedSubscribtion = this.shipmentsUpdatedObservable.subscribe((event) => {
            if (event === true) {
                this.loadShipment();
            }
        });
    }

    loadShipment() {
        this.loading = true;
        forkJoin([
                this.shipmentRoutesService.getShipmentRoutes(),
                this.shipmentsService.getShipment(this.shipmentId, {combineEvents: true})
            ]
        ).subscribe(data => {
            this.allShipmentRoutes = data[0];
            this.shipment = data[1];
            this.shipmentRoutes = this.allShipmentRoutes.filter(route => route.branch === this.shipment.branch);
            this._shipment = _.cloneDeep(this.shipment);
            this.loading = false;
        });
    }
}
